var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courseSuccess"},[_c('div',{staticClass:"img_box"},[_c('img',{attrs:{"src":"https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/pullNew/courseSuccess_btn_new.png"},on:{"click":_vm.goForm}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }